import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Webhooks16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_481)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8 15.75C12.2802 15.75 15.75 12.2802 15.75 8C15.75 3.71979 12.2802 0.25 8 0.25C3.71979 0.25 0.25 3.71979 0.25 8C0.25 12.2802 3.71979 15.75 8 15.75ZM8 1.75C6.99439 1.75 6.55997 4.62441 6.45945 5.25H9.54055C9.44003 4.62441 9.00562 1.75 8 1.75ZM4.94201 5.25H2.38595C3.08176 3.83219 4.29885 2.71656 5.78732 2.15298C5.33887 3.12737 5.09594 4.19319 4.94201 5.25ZM4.78826 6.75H1.87502C1.71105 7.55777 1.71105 8.44222 1.87502 9.25H4.78826C4.73781 8.4349 4.73781 7.5651 4.78826 6.75ZM4.94201 10.75H2.38595C3.08176 12.1678 4.29885 13.2834 5.78732 13.847C5.33887 12.8726 5.09594 11.8068 4.94201 10.75ZM6.45945 10.75H9.54055C9.44003 11.3756 9.00562 14.25 8 14.25C6.99439 14.25 6.55997 11.3756 6.45945 10.75ZM9.70864 9.25H6.29136C6.23724 8.44328 6.23724 7.55672 6.29136 6.75H9.70864C9.76276 7.55672 9.76276 8.44328 9.70864 9.25ZM11.058 10.75C10.9041 11.8068 10.6611 12.8726 10.2127 13.847C11.7011 13.2834 12.9182 12.1678 13.6141 10.75H11.058ZM14.125 9.25H11.2117C11.2622 8.4349 11.2622 7.5651 11.2117 6.75H14.125C14.2889 7.55777 14.2889 8.44222 14.125 9.25ZM10.2127 2.15298C11.7011 2.71655 12.9182 3.83219 13.6141 5.25H11.058C10.9041 4.19319 10.6611 3.12737 10.2127 2.15298Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_481'>
        <rect width='16' height='16' fill='white' />
      </clipPath>
    </defs>
  </Svg>
);

Webhooks16.displayName = 'Webhooks16';
export default Webhooks16;
